import api from '../../api';

const state = {
  app_user: null,
};

const getters = {
  app_user(state) {
    return state.app_user;
  },
};

const mutations = {
  setAppUser(state, payload) {
    state.app_user = payload;

    if (payload.firstName && payload.lastName) {
      state.app_user.initials =
        getInitial(payload.firstName) + getInitial(payload.lastName);
      state.app_user.name = payload.firstName + ' ' + payload.lastName;
    }
  },
};

const actions = {
  async getAppUser(context) {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.getProfile();
        context.dispatch('setAppUser', res.data.user);
        resolve();
      } catch (e) {
        console.error(e);
        reject(e);
      }
    });
  },
  setAppUser(context, payload) {
    context.commit('setAppUser', payload);

    const categories = {};
    if (payload.organization) {
      payload.organization.categories.forEach(cat => {
        categories[cat.id] = cat;
      });
      context.commit('setCategories', categories);
      context.commit('setOrg', payload.organization);
    }
  },
  updateAppUser(context, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        await api.updateProfile(payload);
        resolve();
      } catch (e) {
        console.error(e);
        reject(e);
      }
    });
  },
  reset(context) {
    context.commit('setAppUser', null);
  },
};

const getInitial = str => {
  if (!str || typeof str !== 'string') {
    return '';
  }
  return str.charAt(0).toUpperCase();
};

export default {
  state,
  getters,
  actions,
  mutations,
};
